import { del, get, post, put } from '../client';

export const businessUnitsApi = {
  list: (params) => get('/business-units', { params }),
  getById: (id) => get(`/business-units/${id}`),
  listSites: (id) => get(`/business-units/${id}/sites`),
  create: (body) => post('/business-units', body),
  update: (id, body) => put(`/business-units/${id}`, body),
  remove: (id) => del(`/business-units/${id}`),
};
